@for (setting of (settings() | slice:0:1); track $index) {
<!-- contact area -->
<div class="rts-contact-area contact-one">
    <div class="container">
        <div class="row align-items-center g-0">
            <div class="col-lg-4 col-md-12 col-sm-12 col-12">
                <div class="contact-image-one">
                    <img *ngIf="setting.lightLogo?.path" [src]="setting.lightLogo.path | imageUrl"
                        alt="{{ setting.lightLogo.originalName }}">
                </div>
            </div>
            <div class="col-lg-8 col-md-12 col-sm-12 col-12">
                <app-contact-us-shared></app-contact-us-shared>
            </div>
        </div>
    </div>
</div>

<!-- map area -->
<div class="rts-map-area bg-light-white">
    <div class="container-fluid">
        <div class="row align-items-center">
            <div class="col-lg-6">
                <div class="mapdetails-inner-one">
                    <div class="left-area single-wized">
                        <h5 class="title">{{ "CONTACT.CONTACT" | translate }}</h5>
                        <div class="details">
                            @if(setting.unifiedNumber){
                            <p>{{ "CONTACT.PHONENUMBER" | translate }}</p>
                            <a class="number" [href]="'tel:' + setting.unifiedNumber">
                                <h5 class="phone-number">{{ setting.unifiedNumber }}</h5>
                            </a>
                            }

                            <p class="time-header">
                                {{ "CONTACT.WORKINGHOURS" | translate }}
                            </p>
                            <p class="time">
                                {{ "CONTACT.WORKINGHOURSVALUE" | translate }}
                            </p>
                        </div>
                    </div>
                    @if(setting.address){
                    <div class="right-area single-wized">
                        <h5 class="title">{{ "CONTACT.ASSOCIATIONTITLE" | translate }}</h5>
                        <div class="details">
                            <p>{{ "CONTACT.HEADOFFICE" | translate }}</p>
                            <a>{{ setting.address }}</a>

                            <p class="headoffice">
                                {{ "CONTACT.SUBADDRESS" | translate }}
                            </p>
                            <p class="office">{{ setting.address }}</p>
                        </div>
                    </div>
                    }
                </div>
            </div>
            <div class="col-lg-6">
                <iframe *ngIf="mapUrl" [src]="mapUrl" width="600" height="450" style="border:0;" allowfullscreen=""
                    loading="lazy" referrerpolicy="no-referrer-when-downgrade">
                </iframe>
            </div>
        </div>
    </div>
</div>
}